import React, { useState } from "react";
import { BadgeCheck, ScanLine } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiError } from "@/lib/api";
import { useLang } from "@/i18n";
import { useAuth } from "@/context/AuthContext";

/** Medewerker aan de kassa: standaard de aangemelde gebruiker, wijzigbaar met één badgescan. */
export default function StaffPicker({ staff, setStaff }) {
  const { t } = useLang();
  const { user } = useAuth();
  const [code, setCode] = useState("");
  const current = staff || { name: user?.nickname || user?.name, number: user?.number || "", id: null };

  const lookup = async (value) => {
    try {
      const { data } = await api.post("/staff/by-badge", { code: value });
      setStaff({ id: data.id, name: data.nickname || data.name, number: data.number });
      setCode("");
      toast.success(`${t("seller")}: ${data.nickname || data.name}`);
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="flex flex-wrap items-end gap-3 rounded-xl border border-border bg-muted/40 p-3" data-testid="staff-picker">
      <div className="flex items-center gap-2 min-w-[12rem]">
        <BadgeCheck className="h-5 w-5 text-primary shrink-0" />
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground">{t("seller")}</p>
          <p className="font-semibold text-sm text-foreground" data-testid="staff-name">{current.name}</p>
          {current.number && <p className="text-[11px] text-muted-foreground tabular-nums" data-testid="staff-number">{current.number}</p>}
        </div>
      </div>
      <div className="space-y-1 flex-1 min-w-[12rem]">
        <Label className="text-xs flex items-center gap-1"><ScanLine className="h-3.5 w-3.5" />{t("staff_scan")}</Label>
        <Input
          value={code}
          onChange={(e) => {
            const v = e.target.value;
            setCode(v);
            if (/^\d{13}$/.test(v.trim())) lookup(v.trim());
          }}
          onKeyDown={(e) => { if (e.key === "Enter" && code.trim()) { e.preventDefault(); lookup(code.trim()); } }}
          placeholder={t("staff_scan_ph")}
          data-testid="staff-scan-input"
        />
      </div>
    </div>
  );
}
